import TrendChart from './TrendChart';

const DollarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);

export default function CommissionChart({ data, title, activeTab, onTabChange, loading }) {
  return (
    <TrendChart
      title={title}
      icon={<DollarIcon />}
      data={data}
      activeTab={activeTab}
      onTabChange={onTabChange}
      loading={loading}
      color="var(--series-1)"
      valuePrefix="$"
      emptyText="No commission data for this period"
    />
  );
}
